import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { cn } from '../../lib/utils';
import { SpecraPageHeader } from '../specra/lieutenants';
/**
 * PageHero is the standardized page header for Specra-redesigned root pages.
 *
 * It replaces the legacy global top-bar header (`PageHeader` portal) and the
 * assorted per-page serif `text-xl` headings with one inline treatment
 * (`SpecraPageHeader`: display face, semantic tokens). Pages that use
 * it should hide the global header (`useLayoutStore.setShowHeader(false)`) and
 * render inside `PageBody` and inherit the application theme.
 *
 * @example
 * <PageHero title="History" subtitle="Your past conversations" />
 */ export function PageHero({ title, subtitle, actions, children, className }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: cn('mb-8', className),
        children: [
            /*#__PURE__*/ _jsx(SpecraPageHeader, {
                "data-testid": Testids.pageHero.header,
                title: title,
                description: subtitle,
                actions: actions
            }),
            children
        ]
    });
}
